import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRouteRecommendationAlternateDate } from '../../../../../interfaces/route-recommendations/route-recommendation-alternate-date';
import { RouteRecommendationService } from '../../../../../services/route-recommendation.service';
import { TabViewModule } from 'primeng';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'route-itinerary-date-selector',
  templateUrl: './route-itinerary-date-selector.component.html',
  styleUrls: [
    './route-itinerary-date-selector.component.scss',
    '../../common/scss/route-itinerary-common.scss',
  ],
  standalone: true,
  imports: [TabViewModule, CommonModule],
})
export class RouteItineraryDateSelectorComponent implements OnInit {
  @Input() routeId: number;
  @Output() selectedRouteChange = new EventEmitter<number>();

  @Input() alternateDates: IRouteRecommendationAlternateDate[];

  constructor(private routeRecommendationService: RouteRecommendationService) {}

  ngOnInit(): void {
    this.routeRecommendationService.getItineraryAlternateDates(this.routeId).then((dates) => {
      this.alternateDates = dates;
    });
  }

  onTabChange(event: any) {
    let routeId = this.alternateDates[event.index]?.id;
    this.selectedRouteChange.emit(routeId);
  }
}
